/**
 * Parses a block ID string into a number.
 * NOTE: Make sure to check that the block ID is valid using `isValidBlockId()`
 * before calling this function.
 */
export function parseBlockId(blockId: string): number {
  // remove the 'b' prefix
  const blockIdNumber = blockId.slice(1);

  const number = parseInt(blockIdNumber, 10);

  if (isNaN(number)) {
    throw new Error('Invalid block ID');
  }

  return number;
}
/**
 * Checks that the element's ID starts with 'b' followed by numbers only.
 *
 * @example
 * isValidBlockId('b123') // true
 * isValidBlockId('b123abc') // false
 * isValidBlockId('123') // false
 * isValidBlockId('b123abc') // false
 * isValidBlockId('b123abc') // false
 */
export function isValidBlockIdString(blockId?: unknown): boolean {
  if (typeof blockId !== 'string') {
    return false;
  }

  const validBlockIdFormat = /^b\d+$/;
  return validBlockIdFormat.test(blockId);
}
